import { doc, getDoc, setDoc, deleteDoc } from "firebase/firestore";
import { db } from "./firebase";

/**
 * Agrega un registro de acceso de un colaborador a un módulo.
 */
export const registerAccess = async (
  idCollaborator: string,
  moduleName: string
): Promise<void> => {
  const ref = doc(db, `zeus_users/${idCollaborator}/${moduleName}/sucursales`);
  const data = {
    accessedAt: new Date(),
  };
  await setDoc(ref, data);
};

/**
 * Verifica si un colaborador ha ingresado previamente a un módulo.
 */
export const checkAccess = async (
  idCollaborator: string,
  moduleName: string
): Promise<{ hasAccess: boolean; data: any | null }> => {
  const ref = doc(db, `zeus_users/${idCollaborator}/${moduleName}/sucursales`);
  const snap = await getDoc(ref);

  if (snap.exists()) {
    return { hasAccess: true, data: snap.data() };
  } else {
    return { hasAccess: false, data: null };
  }
};

/**
 * Elimina el registro de acceso a un módulo para un colaborador específico.
 */
export const deleteAccess = async (
  idCollaborator: string,
  moduleName: string
): Promise<boolean> => {
  try {
    const ref = doc(db, `zeus_users/${idCollaborator}/${moduleName}/sucursales`);
    await deleteDoc(ref);
    return true;
  } catch (err) {
    console.error("❌ Error eliminando registro:", err);
    return false;
  }
};
/* Acceso a biometric */
export const checkBiometric = async (
  id_company: any,
): Promise<{data: any | null }> => {
  const ref = doc(db, `zeus_companies/${id_company}`);
  const snap = await getDoc(ref);

  if (snap.exists()) {
    return {data: snap.data() };
  } else {
    return {data: null };
  }
};
